import { FormControlLabel, Radio, useTheme } from '@mui/material';
import { formControlLabelSx } from './FormRadio.style';

export const FormRadio = ({ icon: Icon, value, label }) => {
  const theme = useTheme();

  return (
    <FormControlLabel
      value={value}
      label={label}
      labelPlacement="bottom"
      sx={formControlLabelSx(theme)}
      disableTypography
      control={
        <Radio
          size="large"
          icon={<Icon color={theme.palette.secondary.main} />}
          checkedIcon={<Icon color={theme.palette.quaternary.main} />}
        />
      }
    />
  );
};
